export function getInitialTimePlusMinutes(minutesToAdd: number): { hours: number; minutes: number } {
  const d = new Date();
  d.setMinutes(d.getMinutes() + minutesToAdd);
  return { hours: d.getHours(), minutes: d.getMinutes() };
}
